const rowStyles = {
  mobile: {
    action:
      "flex min-h-[72px] w-full items-center gap-5 border-b border-black/10 text-left dark:border-white/10",
    actionIcon:
      "flex h-8 w-8 shrink-0 items-center justify-center text-black/45 dark:text-white/45",
    actionIconGlyph: "!h-7 !w-7",
    actionPrefix: "text-[15px] font-semibold",
    actionLabel: "min-w-0 truncate text-[17px] font-semibold",
    place:
      "flex min-h-[86px] w-full items-center gap-5 border-b border-black/10 text-left dark:border-white/10",
    placeIcon: "flex h-10 w-10 shrink-0 items-center justify-center text-red",
    placeIconGlyph: "!h-9 !w-9",
    placeCover:
      "h-[60px] w-[60px] shrink-0 rounded-xl border border-black/10 object-cover dark:border-white/10",
    placeName:
      "block truncate text-[18px] font-semibold text-black dark:text-white",
    placeDetails:
      "mt-1 block truncate text-[14px] font-medium text-black/45 dark:text-white/45",
  },
  desktop: {
    action:
      "flex min-h-[48px] w-full items-center gap-3 border-b border-black/10 text-left last:border-b-0 dark:border-white/10",
    actionIcon:
      "flex h-7 w-7 shrink-0 items-center justify-center text-black/40 dark:text-white/40",
    actionIconGlyph: "!h-5 !w-5",
    actionPrefix: "text-[14px] font-semibold",
    actionLabel: "min-w-0 truncate text-[14px] font-semibold",
    place:
      "flex min-h-[52px] w-full items-center gap-3 border-b border-black/10 text-left dark:border-white/10",
    placeIcon: "flex h-8 w-8 shrink-0 items-center justify-center text-red",
    placeIconGlyph: "!h-5 !w-5",
    placeCover:
      "h-[52px] w-[52px] shrink-0 rounded-lg border border-black/10 object-cover dark:border-white/10",
    placeName:
      "block truncate text-[14px] font-semibold text-black dark:text-white",
    placeDetails:
      "mt-1 block truncate text-[12px] font-medium text-black/45 dark:text-white/45",
  },
};

export const getRowStyle = (variant) => rowStyles[variant] || rowStyles.mobile;
